export default "__VITE_PUBLIC_ASSET__99a80ebf__"